import { type ReactNode, useId } from 'react';
import { Input } from '../../components/ui/input';
import { Label } from '../../components/ui/label';

type SearchTextInputProps = {
  searchTerm: string;
  setSearchTerm: (text: string) => void;
  label?: ReactNode;
  placeholder?: string;
};

export const SearchTextInput = ({
  searchTerm,
  setSearchTerm,
  label,
  placeholder,
}: SearchTextInputProps) => {
  const inputId = useId();

  return (
    <div className="grid gap-1.5">
      {label && <Label htmlFor={inputId}>{label}</Label>}
      <Input
        id={inputId}
        value={searchTerm}
        onChange={(event) => setSearchTerm(event.target.value)}
        placeholder={placeholder}
      />
    </div>
  );
};
